<template>
	<v-form
		class="login-form"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
		<div class="d-flex justify-space-between flex-wrap">
			<div style="width: 250px">
				<span class="post-text__field-title">Select Groups</span>

				<v-skeleton-loader class="post-text__field-loader" type="card" v-if="isLoading">
				</v-skeleton-loader>

				<v-select
					v-else
					class="post-text__field-select"
					clearable
					:items="chaptersList"
					item-text="chapter_name"
					variant="solo"
					:menu-props="menuProps"
					return-object
					append-icon="mdi-chevron-down"
					v-model="chapter"
					@change="onSelectChange"
				></v-select>
			</div>

			<div style="width: 250px">
				<span class="post-text__field-title">Link</span>
				<v-text-field
					class="post-text__field-input pt-0"
					color="red"
					v-model="fields.thread_link"
					solo
				>
				</v-text-field>
			</div>
		</div>

		<div class="d-flex justify-space-between flex-wrap" style="margin-top: -20px;">
			<div style="width: 250px">
				<span class="post-text__field-title">Title *</span>
				<v-text-field
					class="post-text__field-input pt-0"
					color="red"
					v-model="fields.thread_title"
					:error-messages="field_errors.required"
					:rules="rules.required"
					required
					solo
				>
				</v-text-field>
				<p
					class="red--text text-center"
					v-for="error in errors"
					:key="error"
					style="width: 100%"
				>
					{{ error }}
				</p>
			</div>

			<div style="width: 250px">
				<span class="post-text__field-title">Tags</span>
				<v-combobox
					v-model="chips"
					:items="tagSelectItems"
					item-text="tag"
					chips
					clearable
					multiple
					solo
					@update:search-input="handlerInputTag"
					@change="debug"
					append-icon="mdi-chevron-down"
					class="post-text__field-input tags-select"
					return-object
				>
					<template v-slot:selection="{ attrs, item, select, selected }">
						<v-chip
							v-bind="attrs"
							:input-value="selected"
							close
							@click:close="remove(item)"
						>
							<strong>{{ item }}</strong>
						</v-chip>
					</template>
				</v-combobox>
			</div>
		</div>

		<div class="d-flex justify-space-between flex-wrap align-start" style="margin-top: -20px;margin-bottom: -20px">
			<div style="width: 100%">
				<span class="post-text__field-title">Text *</span>
				<v-textarea
					class="post-text__field-input pt-0"
					color="transparent"
					style="border-radius: 8px;"
					no-resize
					v-model="fields.thread_text"
					:error-messages="field_errors.required"
					:rules="rules.required"
					required
					rows="4"
				>
				</v-textarea>
				<p
					class="red--text text-center"
					v-for="error in errors"
					:key="error"
					style="width: 100%"
				>
					{{ error }}
				</p>
			</div>

			<div style="width: 250px" v-if="this.activeTab === 1">
				<span class="post-text__field-title">Video Link (required)</span>
				<v-text-field
					class="post-text__field-input pt-0"
					color="red"
					v-model="fields.thread_video"
					:error-messages="field_errors.required"
					:rules="rules.verifyVideo"
					required
					solo
				>
				</v-text-field>
				<p
					class="red--text text-center"
					v-for="error in errors"
					:key="error"
					style="width: 100%"
				>
					{{ error }}
				</p>
			</div>


		</div>
		<div style="width: 255px;margin:40px" class="pb-2 justify-space-between mt-2 margin-left-25" >
			<v-switch
				class="v-input--reverse"
				v-model="fields.allow_comments"
				inset
				:label="`Allow Comments`"
				@change="(value) => handlerAllowComments(value)"
			></v-switch>
		</div>
		<div class="post-text__file-wrapper"  v-if="this.activeTab === 0">
			<div class="post-text__file-container mb-5">
				<v-skeleton-loader
					v-if="this.isFileLoading"
					type="card"
					class="post-text__file-container-loader"
				></v-skeleton-loader>
				<img
					:src="this.fields.thread_image"
					alt="error"
					v-if="fields.thread_image && fields.thread_image.length > 0"
				/>
				<input
					type="file"
					id="file9"
					name="file"
					class="post-text__file-uploader"
					accept="image/png, image/gif, image/jpeg"
					@change="handleUploadFile"
					v-if="!this.fields.thread_image && !this.isFileLoading"
				/>
				<div
					class="d-flex flex-column justify-center align-center post-text__file-container-loader"
					v-if="!this.fields.thread_image && !this.isFileLoading"
				>
					<v-icon :size="50"> mdi-image </v-icon>
					<div class="post-text__file-container-title">
						Drag and Drop or
						<div class="post-text__file-container-link ml-1">Browse</div>
					</div>
					<div class="post-text__file-container-description">
						JPG, PNG. Max size 20 MB
					</div>
				</div>
			</div>

			<div v-if="this.fields.thread_image">
				<div
					class="d-flex align-center mb-1"
					style="cursor: pointer"
					@click="isViewConfirmDeleteImageButtons"
				>
					<Icon
						type="document"
						color="var(--accent-color)"
						:size="24"
						:pr="8"
					/>
					<div class="post-text__confirm-delete-text">Delete Image</div>
				</div>

				<div v-if="showConfirmDeleteImageButtons">
					<div class="post-text__confirm-delete mb-3">
						Are you sure that you want to <br />delete the image?
					</div>
					<div>
						<v-btn
							class="post-text__confirm-button elevation-0 mr-8"
							outlined
							@click="isViewConfirmDeleteImageButtons"
						>
							No
						</v-btn>
						<v-btn
							class="post-text__confirm-button elevation-0"
							:loading="false"
							:disabled="false"
							@click="removeImage"
						>
							Yes
						</v-btn>
					</div>
				</div>
			</div>
		</div>

		<div class="post-text__action-btn-wrapper">
			<v-btn class="post-text__action-btn action-cancel elevation-0 mr-3" outlined @click="closeModal">
				Cancel
			</v-btn>

			<v-btn
				class="post-text__action-btn action-create elevation-0 ml-3"
				:loading="isPostUpdating"
				:disabled="false"
				type="submit"
			>
				{{ edit ? 'Save' : 'Create' }}
			</v-btn>
		</div>

		<p
			class="red--text mt-2 mb-0"
			v-for="error in this.postErrors"
			:key="error"
			style="width: 100%"
		>
			{{ error.message }}
		</p>
	</v-form>
</template>

<script>
import { ruleRequired, ruleVerifyVideo } from '@/utils/rules'
import Form from '@/mixins/Form'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

const DEBOUNCE_TIMEOUT = 500
const TEXT = 0
const VIDEO = 1

export default {
	name: 'PostTextForm',
	mixins: [Form],

	props: {
		activeTab: {
			type: Number,
			default: 0,
		},
		edit: {
			type: Boolean,
			default: false
		},
		post: {
			type: Object,
			default: () => {}
		}
	},

	data: () => ({
		fields: {
			chapter_id: 0,

			thread_title: '',
			thread_text: '',

			thread_image: '',
			thread_video: '',
			thread_link: '',

			allow_comments: 0,

			thread_type: 1,

			tagNames: [],

			thread_menu_id: 1,
			thread_category_id: 1,

			publish_timestamp: Math.floor(Date.now() / 1000),
		},
		chapter: null,

		menuProps: {
			maxWidth: '250px',
			offsetY: true,
		},
		chips: [],
		showConfirmDeleteImageButtons: false,
		timer: 0,
	}),
	computed: {
		...mapGetters('settings', ['isLoading', 'appCore', 'styles']),
		...mapGetters('post', ['isFileLoading', 'postFile', 'postErrors', 'isPostUpdating']),
		...mapGetters('tag', ['tags']),
		...mapGetters('auth', ['profile']),

		rules() {
			return {
				required: [(v) => ruleRequired(v) || 'Field is required.'],
				verifyVideo: [
					(v) => ruleVerifyVideo(v) || 'Video link is incorrect. You must specify a Vimeo or YouTube video link.',
					(v) => ruleRequired(v) || 'Field is required.'
				],
			}
		},
		tagSelectItems() {
			return this.tags.map(item => item.tag)
		},
		chaptersList() {
			return this.profile.chapters.filter(chapter => !chapter.hidden_subgroup)
		}
	},

	methods: {
		...mapActions('post', ['addPost', 'uploadFile', 'editPost']),
		...mapActions('tag', ['fetchTags']),

		async submitForm() {
			if (this.edit) {
				this.fields.thread_type = this.activeTab === 1 ? 3 : 1
				await this.editPost({id: this.post.thread_id, data: this.fields})
				this.closeModal()
			} else {
				if (this.fields.thread_video) {
					this.fields.thread_type = 3
				}
				await this.addPost(this.fields)
				this.closeModal()
			}
		},

		isViewConfirmDeleteImageButtons() {
			this.showConfirmDeleteImageButtons = !this.showConfirmDeleteImageButtons
		},

		onSelectChange(selectedValue) {
			if (selectedValue) {
				this.fields.chapter_id = _.toNumber(selectedValue.chapter_id)
			} else {
				this.fields.chapter_id = null
			}
		},

		remove(item) {
			this.chips.splice(this.chips.indexOf(item), 1)
		},

		handlerInputTag(item) {
			clearTimeout(this.timer)

			this.timer = setTimeout(() => {
				this.fetchTags({ search: item, filter: 'threads' })
			}, DEBOUNCE_TIMEOUT)
		},

		removeImage() {
			this.fields.thread_image = ''
			this.isViewConfirmDeleteImageButtons()
		},
		handlerAllowComments(value) {
			this.fields.allow_comments = _.toNumber(value)
		},

		closeModal() {
			this.$emit('closeModal')
			!this.edit && this.removeImage()
		},

		handleUploadFile(e) {
			const file = e.target.files[0]
			this.uploadFile(file)
		},
		debug(values) {
			this.fields.tagNames = values
		},
		initEditForm() {
			this.fields.allow_comments = this.post.allow_comments
			this.fields.chapter_id = this.post.chapter_id
			this.fields.thread_title = this.post.thread_title
			this.fields.thread_link = this.post.thread_link
			this.fields.thread_image = this.post.thread_image
			this.fields.thread_text = this.post.thread_text
			this.fields.thread_video = this.post.thread_video
			this.fields.thread_type = this.post.thread_type
			this.fields.thread_category_id = this.post.thread_category_id
			this.chapter = this.chaptersList.find(chapter => chapter.chapter_id === this.post.chapter_id)
			const chips = this.post.tags.map(tag => tag.tag)
			this.chips = chips
			this.fields.tagNames = chips
		},
		resetForm() {
			this.initEditForm()
		}
	},

	watch: {
		postFile() {
			this.fields.thread_image = this.postFile.url
		},
		activeTab() {
			if (this.activeTab === TEXT) {
				this.fields.thread_menu_id = 1
			}
			if (this.activeTab === VIDEO) {
				this.fields.thread_menu_id = 3
			}
		},
		chosenCategory: {
			handler() {
				this.selectedCategory = this.chosenCategory
				this.fields.category_id = this.chosenCategory?.category_id || 0
			},
			immediate: true
		}
	},

	created() {
		if (this.appCore) {
			this.fields.thread_menu_id = +this.$route.query.thread_menu_id
			this.fields.thread_category_id = +this.$route.query.category_id
		}
	},

	mounted() {
		this.$refs.form.reset()
		if (this.post) {
			this.initEditForm()
		}
	}
}
</script>

<style lang="scss">
.v-input--reverse{
	margin-left: -25px;
}
.post-text {
	&__field-title {
		width: 29px;
		height: 18px;
		color: rgb(112, 128, 144);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		letter-spacing: -0.34px;
	}

	&__field-loader {
		width: 100%;
		height: 40px;
	}

	&__field-input {
		.menu__content {
			width: 200px !important;
		}
		.v-input__slot {
			min-height: 40px !important;
			height: 40px !important;
			box-shadow: none !important;
			border: 1px solid rgb(223, 223, 223);
		}
		i {
			color: #bbbbbb !important;
		}
		.v-select__selections {
			flex-wrap: nowrap;
			overflow: scroll;
			&::-webkit-scrollbar {
				display: none;
			}
		}
		.v-chip {
			min-width: fit-content;
		}
	}

	&__field-select {
		.v-input__slot:before {
			display: none;
		}
		padding: 0;
		margin: 0;
		.v-select__slot {
			height: 40px;
			border: 1px solid rgb(223, 223, 223);
			border-radius: 6px;
		}

		i {
			margin-top: 10px;
			margin-right: 10px;
			color: #bbbbbb !important;
		}
		button {
			margin-top: 10px;
		}
	}
	&__confirm-delete {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: 500;
		&-text {
			color: var(--accent-color);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			text-decoration: underline;
			letter-spacing: -0.34px;
		}
	}
	&__confirm-button {
		background: var(--button_main_background) !important;
		color: var(--button_main_text_color) !important;
	}
	&__file-wrapper {
		display: flex;
		flex-wrap: wrap;
		column-gap: 40px;
	}
	&__file-container {
		background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23A0A0A0FF' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
		width: 250px;
		height: 130px;
		cursor: pointer;

		img {
			width: 250px;
			height: 130px;
			object-fit: contain;
			cursor: auto;
		}

		input {
			width: 100%;
			height: 130px;
			position: absolute;
			opacity: 0;
			cursor: pointer;
			border-radius: 8px;
		}
		&-file-uploader {
			width: 250px;
			height: 130px;
			position: absolute;
			opacity: 0;
			cursor: pointer;
		}
		&-title {
			display: flex;
			color: rgb(74, 74, 74);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: 500;
			letter-spacing: -0.34px;
		}
		&-description {
			color: rgb(112, 128, 144);
			font-size: 12px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			text-align: center;
			letter-spacing: -0.29px;
		}
		&-link {
			color: rgb(66, 160, 216);
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			text-decoration: underline;
		}
		&-loader {
			height: 135px;
		}
	}

	&__action-btn {
		font-size: 15px !important;
		font-weight: 700;
		text-transform: capitalize;
		font-family: Montserrat, sans-serif;
		padding: 0 32px !important;
		border-radius: 8px !important;
		border: 2px solid var(--button-main-background-color);
		width: auto !important;

		@media (max-width: 480px) {
			flex-grow: 1;
			padding: 0 !important;
		}

		&-wrapper {
			display: flex;
			justify-content: center;
			column-gap: 8px;

			.action-create {
				background: var(--button-main-background-color) !important;
				color: var(--button-main-color) !important;
				height: 42px !important;
				border-radius: 8px !important;
			}

			.action-cancel {
				background: var(--button-main-color) !important;
				color: var(--button-main-background-color) !important;
				height: 42px!important;
				border-radius: 8px !important;
			}
		}
	}
}

.v-input--reverse .v-input__slot {
	border: none !important;
	flex-direction: row-reverse;

	.v-application--is-ltr & {
		.v-input--selection-controls__input {
			margin-right: 0;
			margin-left: 8px;
		}
	}
	.v-application--is-rtl & {
		.v-input--selection-controls__input {
			margin-left: 0;
			margin-right: 8px;
		}
	}
}

.v-menu__content {
	width: 250px;
}
textarea {
	padding: 10px !important;
}
.tags-select {
	input {
		padding-bottom: 8px !important;
	}
}
</style>
